const state = {
  chats: [],
  currentChat: {},
  badgeNumber: 0,
};

const getters = {
  chats(state) {
    return state.chats;
  },
};

const mutations = {
  setChats(state, chats) {
    state.chats = chats;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
